import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import { DATA_INPUT_RULES, access } from '../../access';

const ManualSensors = withLazyLoading(() => import('../../pages/manualSensors'));

const manualInputRoutes = [
  {
    path: '/manual-sensors',
    handle: createCrumbHandle('Manual Sensors'),
    children: [
      {
        index: true,
        element: <ManualSensors />,
        handle: access(DATA_INPUT_RULES.templates),
      },
    ]
  },
];

export default manualInputRoutes;
